import styled from 'styled-components';
import { Form as FormComponent } from '@unform/web';

export const Form = styled(FormComponent)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
